import { z } from 'zod';

import { LIMITS } from '../constants.js';

import { isoDateTimeSchema, uuidSchema } from './common.js';

export const companyNoteSchema = z.object({
  id: uuidSchema,
  /** Public numeric id — used in browser URLs (/companies/:id/notes/100000042). */
  number: z.number().int().positive(),
  clientId: uuidSchema,
  title: z.string().min(1).max(200),
  body: z.string().max(LIMITS.companyNoteBodyMax),
  createdAt: isoDateTimeSchema,
  updatedAt: isoDateTimeSchema,
});
export type CompanyNoteDto = z.infer<typeof companyNoteSchema>;

export const createCompanyNoteSchema = z.object({
  title: z.string().min(1, 'Введите заголовок').max(200),
  body: z.string().max(LIMITS.companyNoteBodyMax).default(''),
});
export type CreateCompanyNoteDto = z.infer<typeof createCompanyNoteSchema>;

export const updateCompanyNoteSchema = z
  .object({
    title: z.string().min(1).max(200),
    body: z.string().max(LIMITS.companyNoteBodyMax),
  })
  .partial();
export type UpdateCompanyNoteDto = z.infer<typeof updateCompanyNoteSchema>;
